export default __webpack_public_path__ + "static/media/puerto.fbae0fbf.jpg";